import dialogType from '../../../../../../../display/dialogs/dialogType'

import Method from '../../../../../../../net/Method'

const ageRanges =
{
    title : 'Tranches d\'âges' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner une ou plusieurs tranches d\'âge dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        method      : Method.PATCH,
        mock        : false ,
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Tranches d\'âge' ,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default ageRanges ;